module.exports = __webpack_public_path__ + "static/media/WS5.b73662eb.jpg";